<template>
  <!-- <div
    style="position: fixed; top:0px; bottom:0px; left:0px; right:0px; z-index:100112; background-color: white; display: flex; flex-direction: column; align-items: center;"
  >
      <img src="@/assets/images/spinner.gif" />
      <p class="paragraph-3">{{$t(msg)}} {{$t(msg2)}}</p>
      <h2 style="margin-bottom:0px">{{$t(msg)}}</h2>
      <h2 v-if="msg2" style="margin-top:0px">{{$t(msg2)}}</h2>
  </div> -->
  <div class="sub_container w-row loader-screen">
    <div class="column-10 w-col w-col-3"></div>
    <div class="column-2 w-col w-col-6">
      <img class="gear" :src="require('@/assets/images/spinner-of-dots.svg')" width="100px" height="100px" />
      <p class="paragraph-3">{{ $t(msg) }} {{ $t(msg2) }}</p>
    </div>
    <div class="column-16 w-col w-col-3"></div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    msg: {
      type: String,
      default: 'GETTING_DATA_PATIENT'
    },
    msg2: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.loader-screen {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  flex-direction: column;
  align-items: center;
  z-index: 100112;
  margin-top: 0px;
  background-image: url('~@/assets/images/mono-back-11.png');
   background-position: 50% 50%;
  background-size: cover;
  display: flex;
  justify-content: center;
  // height: 100%;
}
.gear {
    -webkit-animation: rotation 2s infinite linear;
    -moz-animation: rotation 2s infinite linear;
    -o-animation: rotation 2s infinite linear;
    animation: rotation 2s infinite linear;
    transform-origin: 50% 50%;
    -webkit-transform-origin: 50% 50%;
    -moz-transform-origin: 50% 50%;
}

@-webkit-keyframes rotation {
    from {-webkit-transform: rotate(0deg);}
    to   {-webkit-transform: rotate(359deg);}
}
@-moz-keyframes rotation {
    from {-moz-transform: rotate(0deg);}
    to   {-moz-transform: rotate(359deg);}
}
@-o-keyframes rotation {
    from {-o-transform: rotate(0deg);}
    to   {-o-transform: rotate(359deg);}
}
@keyframes rotation {
    from {transform: rotate(0deg);}
    to   {transform: rotate(359deg);}
}
</style>
